export const DataUriToFile = (dataURI, filename) => {
    let arr = dataURI.split(','),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n)

    while (n--) {
        u8arr[n] = bstr.charCodeAt(n)
    }

    const extname = mime.split('/')[1].replace(`quicktime`, `mov`)
    return new File([u8arr], `${filename}.${extname}`, { type: mime })
}